// Vendor imports
const _ = require('lodash')
// Client V2 common imports
const collectionSelectModalActions = require('client-v2/common/containers/collection-select-modal/actions')
const collectionSelectModalSelectors = require('client-v2/common/containers/collection-select-modal/selectors')
const articleModelActions = require('client-v2/common/models/article/actions')
const collectionModelActions = require('client-v2/common/models/collection/actions')
const userModelActions = require('client-v2/common/models/user/actions')
// Container imports
const feedActions = require('../containers/feed/actions')

/** @typedef { import('redux').Middleware } ReduxMiddleware */

// Middlewares

/**
 * @returns {ReduxMiddleware}
 */
function collectionProfileDeletedSideEffectMiddleware() {
  return store => next => action => {
    const state = store.getState()
    if (
      action.type === collectionModelActions.COLLECTION_DELETED &&
      state.collection.id === _.get(action, 'payload.collectionId')
    ) {
      store.dispatch(userModelActions.navigateToUserProfileCollections({
        user: state.collection
      }))
    }
    next(action)
  }
}

/**
 * @returns {ReduxMiddleware}
 */
// eslint-disable-next-line complexity
function collectionProfileShowPostsSideEffectsMiddleware() {
  let delayedRemoveArticlePayload = null
  return store => next => action => {
    const state = store.getState()
    if (state.router.action !== 'collection-profile.showPosts') {
      return next(action)
    }
    if (state.collection.id === _.get(action, 'payload.collectionId')) {
      if (action.type === articleModelActions.ARTICLE_ADDED_TO_COLLECTION) {
        store.dispatch(feedActions.prependArticle(action.payload))
        delayedRemoveArticlePayload = null
      }
      if (action.type === articleModelActions.ARTICLE_REMOVED_FROM_COLLECTION) {
        if (collectionSelectModalSelectors.isLightweightModalVisible(state)) {
          /**
           * Work-around LWE modal disappearing when the article is removed from the feed.
           * Delay removal so that articles can be easily re-added in case of accidental click
           */
          delayedRemoveArticlePayload = action.payload
        } else {
          store.dispatch(feedActions.removeArticle(action.payload))
        }
      }
    }
    if (action.type === collectionSelectModalActions.HIDE) {
      // If LWE modal disappears, flush the delayed removal
      if (delayedRemoveArticlePayload) {
        store.dispatch(feedActions.removeArticle(delayedRemoveArticlePayload))
        delayedRemoveArticlePayload = null
      }
    }
    next(action)
  }
}

// Exports

module.exports = {
  collectionProfileDeletedSideEffectMiddleware,
  collectionProfileShowPostsSideEffectsMiddleware
}
